import { AssetScaleType } from "../../enums/SDKAssetScaleType";
import { DocsImageRefType, } from "../blocks/support/SDKDocsImageRef";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityHeader {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.description = model.description;
        this.alignment = model.alignment;
        this.foregroundColor = (_a = model.foregroundColor) !== null && _a !== void 0 ? _a : null;
        this.backgroundColor = (_b = model.backgroundColor) !== null && _b !== void 0 ? _b : null;
        this.showBackgroundOverlay = model.showBackgroundOverlay;
        this.showCoverText = model.showCoverText;
        this.minHeight = (_c = model.minHeight) !== null && _c !== void 0 ? _c : null;
        this.backgroundImageScale =
            (_d = model.backgroundImageScaleType) !== null && _d !== void 0 ? _d : AssetScaleType.aspectFill;
        if (model.backgroundImageAsset) {
            if (model.backgroundImageAsset.type === "Resource" &&
                model.backgroundImageAsset.resource) {
                this.backgroundImage = {
                    type: DocsImageRefType.resource,
                    resource: {
                        resourceId: model.backgroundImageAsset.resource.resourceId,
                        url: model.backgroundImageAsset.resource.url,
                    },
                };
            }
            else if (model.backgroundImageAsset.type === "FigmaNode" &&
                model.backgroundImageAsset.figmaNode) {
                this.backgroundImage = {
                    type: DocsImageRefType.figmaNode,
                    figmaNode: {
                        frameReferenceId: model.backgroundImageAsset.figmaNode.frameReferenceId,
                        sourceId: model.backgroundImageAsset.figmaNode.sourceId,
                    },
                };
            }
            else {
                this.backgroundImage = null;
            }
        }
        else {
            this.backgroundImage = null;
        }
    }
    toRemote() {
        const model = {
            description: this.description,
            alignment: this.alignment,
            showBackgroundOverlay: this.showBackgroundOverlay,
            showCoverText: this.showCoverText,
            minHeight: this.minHeight,
            foregroundColor: this.foregroundColor,
            backgroundColor: this.backgroundColor,
            backgroundImageAsset: null,
            backgroundImageScaleType: this.backgroundImageScale,
        };
        if (this.backgroundImage) {
            if (this.backgroundImage.type === DocsImageRefType.resource &&
                this.backgroundImage.resource) {
                model.backgroundImageAsset = {
                    type: "Resource",
                    resource: {
                        resourceId: this.backgroundImage.resource.resourceId,
                        url: this.backgroundImage.resource.url,
                    },
                };
            }
            else if (this.backgroundImage.type === DocsImageRefType.figmaNode &&
                this.backgroundImage.figmaNode) {
                model.backgroundImageAsset = {
                    type: "FigmaNode",
                    figmaNode: {
                        frameReferenceId: this.backgroundImage.figmaNode.frameReferenceId,
                        sourceId: this.backgroundImage.figmaNode.sourceId,
                    },
                };
            }
        }
        return model;
    }
}
